const accordionsHolders = document.querySelectorAll('.lsg-js-accordions');
const showTextClass = 'show-text'; // Variable for the class name

if (accordionsHolders && accordionsHolders.length) {
    accordionsHolders.forEach(holder => {
        const accordions = holder.querySelectorAll('.lsg-accordion');

        accordions.forEach(accordion => {
            const accordionBtn = accordion.querySelector('.lsg-accordion__header');
            const panel = accordion.querySelector('.lsg-accordion__panel');

            panel.style.maxHeight = null;

            accordionBtn.addEventListener('click', () => {
                const activeAccordion = holder.querySelector(`.${showTextClass}`);

                if (activeAccordion && activeAccordion !== accordion) {
                    activeAccordion.classList.remove(showTextClass);
                    activeAccordion.querySelector('.lsg-accordion__panel').style.maxHeight = null;
                }

                accordion.classList.toggle(showTextClass);
                panel.style.maxHeight = accordion.classList.contains(showTextClass) ? panel.scrollHeight + 'px' : null;
            });
        });
    });
}

const faqPrevArrow = `<button type="button" class="slick-prev lsg-50-50__arrow--prev"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill="#232323"/>
<path d="M23 24L26 20L23 16" stroke="white" stroke-width="1.5"/>
<path d="M26 20H14" stroke="white" stroke-width="1.5"/>
</svg>
</button>`;

const faqNextArrow = `<button type="button" class="slick-next lsg-50-50__arrow--next"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 40 0)" fill="#232323"/>
<path d="M23 24L26 20L23 16" stroke="white" stroke-width="1.5"/>
<path d="M26 20H14" stroke="white" stroke-width="1.5"/>
</svg>
</button>`;

$(document).ready(function () {
    $('.lsg-50-50__image-slider').slick({
        dots: false, // Show navigation dots
        arrows: true,
        infinite: true, // Infinite loop
        speed: 500, // Transition speed
        slidesToShow: 1, // Number of slides to show at once
        fade: true,
        slidesToScroll: 1,
        prevArrow: faqPrevArrow,
        nextArrow: faqNextArrow,
        responsive: [
            {
                breakpoint: 1024, // For screens <= 1024px
                settings: {
                    dots: true,
                    arrows: false
                }
            },
        ],
    });
});
